import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";

export const programme = {
  id: "thermal-power",
  name: "Thermal Power Engineering",
  short: "Thermal Power",
  programmeType: "pg",
  programmeLabel: "Postgraduate Programme",
  hideSharedClubs: true,
  hideFacultySection: true,
  hideAcademicMeta: true,
  duration: "2 Years",
  intake: 12,
  established: 2013,

  description: [
    "The M.Tech. programme in Thermal Power Engineering is designed to develop the analytical, technical, and research competencies required to address challenges in the field of thermal power generation. Thermal power plants continue to play a crucial role in meeting the growing energy demands of the nation, making this specialization highly relevant to the power sector.",

    "The department received approval from the All India Council for Technical Education (AICTE) to offer the M.Tech. programme in Thermal Power Engineering under the Department of Mechanical Engineering from the academic year 2013–14, with an intake of 12 students. The programme is affiliated to Visvesvaraya Technological University (VTU), Belagavi. Graduates holding a Bachelor's degree in Mechanical Engineering, Industrial Production Engineering, Manufacturing Engineering, or an equivalent qualification, as well as AMIE candidates in the relevant discipline, are eligible for admission.",

    "The programme offers advanced knowledge in thermal sciences with a focus on both theoretical concepts and practical applications. The curriculum covers key areas such as fluid flow, heat transfer, thermal energy systems, refrigeration and air-conditioning, internal combustion engines, and non-conventional energy resources. The core courses provide a strong foundation for pursuing specialized electives and undertaking research projects in areas such as heat transfer, fluid dynamics, thermal system design, and the development of energy-efficient components.",

    "Laboratory experiments, industrial interactions, and research-oriented activities are integrated into the programme to bridge the gap between academic learning and industrial requirements. The curriculum is designed in consultation with industry experts and research organizations to equip students with the skills needed for careers in power generation, energy management, research and development, and higher studies.",
    
  ],

  image:
    "/Campus/thermalhero.jpg",

  hodId: null,

  // dashboard: [
  //   ["Faculty Members", ""],
  //   ["Faculty with Ph.D.", ""],
  //   ["Students Enrolled", ""],
  // ],

  academicOverview: [],

  curriculumSupport: [],

  achievements: [],

  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
};

const ThermalPowerEngineering = () => (
  <ProgrammeDetail programme={programme} />
);

export default ThermalPowerEngineering;
